import React, {useState} from 'react';
import { Link } from 'wouter';
import logografico from './../assets/images/isotipo.png'
import MenuIcon from '@mui/icons-material/Menu';

import 'animate.css';

const Header: React.FC<{ navegacionFija: boolean, seccionActual: string, cambiarSeccion(nuevaSeccion: string): void }> = ({navegacionFija, seccionActual, cambiarSeccion }) => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const localCambiarSeccion = (nuevaSeccion: string) => {
    cambiarSeccion(nuevaSeccion);
    setIsMenuOpen(false);
  };

  return (
    <div className='container-fluid flex flex-col items-start justify-center'>
      <nav className={`bg-stone-100 w-full border-b border-gray-200 opacity-85 shadow-md shadow-vp-gris top-0 start-0 ${navegacionFija ? 'z-20 fixed' : ''}`}>
        <div className="w-full flex flex-nowrap items-center justify-between p-3 xl:px-10">
          <a href="https://www.vidaplus.com.ar" className="flex items-center justify-center">
              <img src={logografico} className="h-8 block" alt="VidaPlus Logo" />
          </a>
          {/* Menú principal */}
          <div className={`container-fluid justify-between items-center flex-grow hidden sm:flex sm:w-auto`}>
            <ul className={`flex flex-row flex-grow justify-end space-x-2 md:space-x-4 lg:space-x-8 xl:space-x-10 mr-4 md:mr-8`} >
              <li className='flex my-2'>
                <Link to='/#inicio' className={`${seccionActual === 'inicio' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'}`} onClick={() => cambiarSeccion('inicio')}>Inicio</Link>
              </li>
              <li className='flex my-2 '>
                <Link to='/#asociate' className={`${seccionActual === 'asociate' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'}`} onClick={() => cambiarSeccion('asociate')}>Asociate</Link>
              </li>
              <li className='flex my-2'>
                <Link to="/#servicios" className={`${seccionActual === 'servicios' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'}`} onClick={() => cambiarSeccion('servicios')}>Servicios</Link>            
              </li>
              <li className='flex my-2'>
                <Link to="/#planes" className={`${seccionActual === 'planes' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'}`} onClick={() => cambiarSeccion('planes')}>Planes</Link>            
              </li>
              <li className='flex my-2'>
                <Link to="/#contacto" className={`${seccionActual === 'contacto' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'}`} onClick={() => cambiarSeccion('contacto')}>¿Tenés&nbsp;Dudas?</Link>
              </li>
            </ul>
          </div>
          <div className="flex flex-row flex-nowrap justify-center items-center">
              <button onClick={toggleMenu} type="button" className="inline-flex items-center p-2 w-10 h-11 mr-2 justify-center text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 ">
                <MenuIcon />
            </button>
              <div className="flex flex-row fles-nowrap" >
                <Link to="/Credencial">
                  <button className="vp-btn-azul shadow-md shadow-vp-gris mr-2">Tu Credencial</button>
                </Link>
                <Link to="/Cotizador">
                  <button className="vp-navbar-btn-call-to-action shadow-md shadow-vp-gris" type="button" onClick={() => cambiarSeccion('cotizador')} disabled={seccionActual === 'cotizador'}>Cotizar YA!</button>
                </Link>
              </div>   
          </div>
        </div>
      
        {/* Menú desplegable */}
        <div className={`container-fluid fixed flex-col flex-grow w-full bg-stone-100 shadow-md shadow-vp-gris border-t-2 border-b-2 ${isMenuOpen ? 'flex bg-opacity-100':'hidden'} sm:hidden`}>
          <ul className={`container-fluid flex flex-col flex-grow w-full pl-6 `}>
            <li className='flex my-2'>
              <Link to="/#inicio" className={`${seccionActual === 'inicio' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'} cliqueable`} onClick={() => localCambiarSeccion('inicio')}>Inicio</Link>
            </li>
            <li className='flex my-2 '>
              <Link to="/#asociate" className={`${seccionActual === 'asociate' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'} cliqueable`} onClick={() => localCambiarSeccion('asociate')}>Asociate</Link>
            </li>
            <li className='flex my-2'>
              <Link to="/#servicios" className={`${seccionActual === 'servicios' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'} cliqueable`} onClick={() => localCambiarSeccion('servicios')}>Servicios</Link>            
            </li>
            <li className='flex my-2'>
              <Link to="/#planes" className={`${seccionActual === 'planes' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'} cliqueable`} onClick={() => localCambiarSeccion('planes')}>Planes</Link>            
            </li>
            <li className='flex my-2'>
              <Link to="/#contacto" className={`${seccionActual === 'contacto' ? 'vp-navbar-btn-efecto-seleccionado' : 'vp-navbar-btn-efecto'} cliqueable`} onClick={() => localCambiarSeccion('contacto')}>¿Tenés&nbsp;Dudas?</Link>            
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Header;
